import React, { FunctionComponent } from 'react'
import Main from "../Main/Main"
import styles from './OIDCCallbackError.module.scss'

interface Props {
    error: string
}

const OIDCCallbackError: FunctionComponent<Props> = () => (
    <Main centeredWithoutStyles>
        <section className={styles.error}>
            <header className={styles.header}>
                <h1 className="sr-only">Kipsu</h1>
            </header>
            <section className={styles.body}>
                <h2>Uh-oh! An Error Occurred.</h2>
                <p>Please contact Kipsu Support for more details.</p>
            </section>
            <section className={styles.body}>
                <h2>On a Mobile Device?</h2>
                <a className={styles.link}
                   href="https://apps.apple.com/us/app/kipsu/id905528393"
                   target="_blank"
                   rel="noreferrer"><p>(iOS) Download Kipsu on the Apple App Store</p></a>
                <a className={styles.link}
                   href="https://play.google.com/store/apps/details?id=com.kipsu.kipsu_android&hl=en_US"
                   target="_blank"
                   rel="noreferrer"><p>(Android) Download Kipsu on the Google Play Store</p></a>
            </section>
        </section>
    </Main>
)

export default OIDCCallbackError
